import './index.less'
import './thumb.less'



// WEBPACK FOOTER //
// ./ecology9/wea-table-page/style/index.js